export default __webpack_public_path__ + "92425c623934facef057b0cfe2e13f95.woff2";